import request from '@/utils/request'

// export function gettbldmngp(bldmngno) {
//   return request({
//     url: `/api/tbldmngp/` + bldmngno,
//     method: 'get',
//   })
// }

export function gettbldmngp(bldmngno, mngseq) {
  return request({
    url: '/api/tbldmngp',
    method: 'get',
    params: { bldmngno: bldmngno, mngseq: mngseq },
  })
}
